export default __webpack_public_path__ + "assets/img/Group49.33039b82.svg";